import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  baseUrl = environment.apiUrl;
  // baseUrl = 'https://ohssdsapidev.azurewebsites.net/api/v1/';
  // baseUrl = 'https://ohssandboxqa.healthcarebc.ca/sdsapi/api/v1/';
  // baseUrl: 'https://sds.healthcarebc.ca/sdsapi/api/v1/';

constructor(
  private http: HttpClient) { }

generateReport(selection: any, model: any) {
  let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
  }
  // tslint:disable-next-line: max-line-length
  return this.http.post(this.baseUrl + `Report/ExportProducts?${selection}`, model, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
}

generateUserReport(selection: any) {
  let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
  }
// tslint:disable-next-line: max-line-length
  return this.http.get(this.baseUrl + `Report/ExportUsers?${selection}`, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
}

generateSiteReport(model: any) {
  let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
  }
  // tslint:disable-next-line: max-line-length
  return this.http.post(this.baseUrl + `Report/ExportSites`, model, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' }
  );
}

generateManufacturerReport(selection: any) {
  let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
  }
    // tslint:disable-next-line: max-line-length
  return this.http.get(this.baseUrl + `Report/ExportManufacturers?${selection}`, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
}

}